'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'car-wrench';
var width = 512;
var height = 512;
var aliases = ["car-mechanic"];
var unicode = 'f5e3';
var svgPathData = 'M48.6 12c8.5-7.5 19.6-12 31.7-12 26.5 0 48 21.5 48 48s-21.5 48-48 48c-12.2 0-23.3-4.5-31.7-12-6.6-5.8-16.7-5.2-22.6 1.4s-5.2 16.7 1.4 22.6c14.1 12.4 32.6 20 52.9 20 38.7 0 71-27.5 78.4-64l195.2 0c7.4 36.5 39.7 64 78.4 64 20.3 0 38.8-7.6 52.9-20 6.6-5.8 7.3-16 1.4-22.6s-16-7.3-22.6-1.4c-8.5 7.5-19.6 12-31.7 12-26.5 0-48-21.5-48-48s21.5-48 48-48c12.2 0 23.3 4.5 31.7 12 6.6 5.8 16.7 5.2 22.6-1.4s5.2-16.7-1.4-22.6c-14.1-12.4-32.6-20-52.9-20-38.7 0-71 27.5-78.4 64L158.7 32c-7.4-36.5-39.7-64-78.4-64-20.3 0-38.8 7.6-52.9 20-6.6 5.8-7.3 16-1.4 22.6S42 17.8 48.6 12zM164.2 176l184.2 0c14.2 0 26.7 9.4 30.7 23l21.5 73-288.5 0 21.5-73c4-13.6 16.5-23 30.7-23zm-61.4 13.9L77.9 274.7c-26.4 7.9-45.6 32.4-45.6 61.3l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 384 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160c0-28.9-19.2-53.4-45.6-61.3l-24.9-84.7c-8-27.2-33-45.9-61.4-45.9l-184.2 0c-28.4 0-53.4 18.7-61.4 45.9zM448.3 384l0 48-384 0 0-96c0-17.7 14.3-32 32-32l320 0c17.7 0 32 14.3 32 32l0 48zm-320 8a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm280-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCarWrench = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;